import { isDev } from '@/lib/isDev';
import { useAuth } from '@clerk/react';
import { useCallback } from 'react';

// Use direct API Gateway URL in production to avoid CloudFront routing issues
const basePath = isDev
  ? '/api/v0/admin/'
  : import.meta.env.VITE_API_BASE_URL || '/api/v1/admin/';

export function useAuthenticatedFetch() {
  const { getToken, isLoaded } = useAuth();

  return useCallback(
    async (input: RequestInfo | URL, init?: RequestInit) => {
      if (!isLoaded) {
        throw new Error('Authentication is not ready yet.');
      }

      const token = await getToken({ template: 'default' });
      const headers = new Headers(init?.headers);

      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      if (
        !headers.has('Content-Type') &&
        init?.body &&
        !(init.body instanceof FormData)
      ) {
        headers.set('Content-Type', 'application/json');
      }

      // Prepend basePath to relative URLs
      const url = `${basePath}${input}`;
      return fetch(url, {
        ...init,
        headers,
      });
    },
    [getToken, isLoaded],
  );
}
